<template>
  <div class="el-main-1" style="background-color:ghostwhite;margin-top: 20px;">
    <el-row type="flex">
      <el-col :span="5">
        <div style="background-color:#fff">
          <div style="margin-left: 10px; margin-left: 10px;   text-align: left;  color: #0162c3 ; font-weight: bold; height: 60px; display: flex ;align-items: center; ">
            <i class="el-icon-position"> </i>规章制度
          </div>
          <el-menu default-active="0" @select="handleSelect" style="background-color:#fff;text-align: left;" >
            <el-menu-item index="0" style="margin: 0px; font-size: 20px; ">全部</el-menu-item>
            <el-menu-item  index='1' style="margin: 0px; font-size: 20px; ">国家规定</el-menu-item>
            <el-menu-item  index='2'  style="margin: 0px; font-size: 20px; ">地方文件</el-menu-item>
            <el-menu-item  index='3'  style="margin: 0px; font-size: 20px; ">其余文件</el-menu-item>
          </el-menu>
        </div>
      </el-col>
      <el-col :span="19" style="margin-left:50px">
        <div style="background-color:#fff; " >
          <el-breadcrumb separator="/"  style="height:60px; font-size:20px;  display: flex ;align-items: center;">
            <el-breadcrumb-item ><a class=""  v-on:click ="routeFunc" >首页</a></el-breadcrumb-item>
            <el-breadcrumb-item >规章制度</el-breadcrumb-item>
            <el-breadcrumb-item >{{ pager.pageDir }}</el-breadcrumb-item>
          </el-breadcrumb>
          <el-divider></el-divider>
          <div>
            <div class="tzgg-ul">
              <div v-for="(reg, index) in regList" :key="index" class="text tzgg-ul-li">
                <i class=""></i> 
                <a class="" @click="routeFuncDetail(reg.id)">{{  reg.theme }}</a>
                <span class="">{{ reg.createTime }}</span>
              </div>  
            </div>
          </div>
          <el-pagination
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="pager.pageSize"
            :total="pager.totalCount" style="margin-top : 20px; margin-bottom: 20px;">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>                        
<script>
// 引入组件
import axios from  '@/api/axiosConfig'
import SERVICE_URL  from  '@/api/url'
import {MESSAGE_DURATION} from  '@/api/constant'
export default {
  name : 'pc_reg',
  data() {
    return {
      regList:[],
      pager:{
        pageDir :'全部',
        totalCount:0,
        pageSize : 10                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
      },
    }
  },
  methods : {
    routeFunc(){
      window.parent.postMessage({
        data: "1",
      }, '*');
    },
    routeFuncDetail(id){
      let left0 =  (window.screen.availWidth-10-1000)/2
      let params0 = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
      width=1000,height=1000,left=${left0},top=100`;
      window.open(SERVICE_URL+ "/#/pc_editor_view/" +id +"?fileType=规章制度" ,"test",params0);
    },
    handleCurrentChange(val){
      this.regListLoad(val)
    },

    handleSelect(index){
      let levelType = '';
      if(index == '0'){
        levelType = ''
      }else if(index == '1') {
        levelType = '国家规定'
      }else if(index == '2') {
        levelType = '地方文件'
      }else if(index == '3') {
        levelType = '其余文件'
      }
      this.regListLoad(1,levelType)
    },

    regListLoad(pageNo,type){
      let url = "/bc/exa/reg/regPage"
      let dat0 = {
          pageSize:10,
          pageNo,
          type,
          adminInfInvoke:false
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.data.length !== 0){
            this.regList.splice(0)
            dat.data.forEach(t=>this.regList.push(t))
            this.pager.totalCount = dat.totalDataCount
            if(type !== ''){
               this.pager.pageDir = type
            }else{
              this.pager.pageDir = '全部'
            }
     
          } else {
            this.$message({
              showClose: true,
              message: '未查询到规章制度信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        });
      },
    },
    created(){

      setTimeout(()=>{ this.regListLoad(1,"") },200)
    },
    components: {
    }
  }
</script>
  
<style lang="less" scoped>

.el-main-1 {
  width: 100%;
  margin-top:0px;
  padding: auto;
  color: #333;
  text-align: center;
  height: calc(100% - 20px);
  overflow:auto;
}
.el-menu-item.is-active {
  background-color:  rgb(124, 203, 199);
}
.el-row {
  padding: auto;
  margin: auto;
  height: 300px;
  width: 1400px;
  font-size: large;
  text-align: center;
}

.el-divider--horizontal{
  background-color: #2577d5;
  height: 2px;
  margin: 1px 0 10px 0;
  width: 100%
}


.tzgg-ul{
    width:90%;
    margin: auto;
    &:first-child {
      margin-top: 20px;
    }
    .tzgg-ul-li{
      height: 50px;
      line-height: 18px;
      font-size: 18px;
      border-bottom: 1px solid #DCDFE6;
      display: flex ;
      align-items: center;
      i{
        width:5px;
        height:5px;
        display:inline-block;
        background-color:rgb(124, 203, 199);
        margin-bottom: 5px;
        margin-left: 5px;
        transform:rotate(45deg);
      }
      a{
        width:75%;
        overflow: hidden;
        padding-left: 1em;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
        text-align: left;
        font-size: 1em;
      }
      span{
        width:20%;
        display:inline-block;
        font-size: 0.8em;
        color: #6F6F6F;
        white-space: nowrap;
        text-align: right;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
</style>
  


// WEBPACK FOOTER //
// src/pc_pages/pc_component/pc_reg.vue